class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    if (this.header) this.header.reveal();
    this.open();

    // Barre livraison après ajout au panier
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => this.updateShippingBar(cart))
      .catch(() => {});
  }

  updateShippingBar(cart) {
    const FREE_SHIPPING = 75;
    const totalEuros = cart.total_price / 100;
    const remaining = FREE_SHIPPING - totalEuros;
    const percent = Math.min((totalEuros / FREE_SHIPPING) * 100, 100);
    const msg = document.getElementById('soan-shipping-message');
    const bar = document.getElementById('soan-shipping-progress');
    if (!msg || !bar) return;
    bar.style.width = percent + '%';
    if (remaining <= 0) {
      msg.innerHTML = '<strong style="color:#2a7a2a">🎉 Livraison offerte&nbsp;!</strong> Votre commande est éligible.';
      bar.style.background = '#2a7a2a';
    } else {
      const r = remaining.toFixed(2).replace('.', ',');
      msg.innerHTML = 'Plus que <strong>' + r + '€</strong> pour la livraison offerte';
      bar.style.background = '#C9A84C';
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
